import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SPINNER_FADEOUT_DURATION } from '../app.constants';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({
                opacity: 0
            })),
            state('*', style({
                opacity: 1
            })),
            transition('void => *', animate(`${SPINNER_FADEOUT_DURATION}ms ease-in`)),
            transition('* => void', animate(`${SPINNER_FADEOUT_DURATION}ms ease-out`))
        ])
    ],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
